<template>
  <div class="aaa">
    <div class="wwww">
      <div class="subject_name">
        {{ subjectlist.sortCode }}.{{ subjectlist.question }}
      </div>
      <div class="subject_option">
        <van-radio-group v-model="R_idnex" v-if="subjectlist.type == 1">
          <van-radio
            class="subject_radio"
            icon-size="18px"
            v-for="(item, index) in subjectlist.options"
            @click="
              getanswer(
                subjectlist.id,
                R_idnex,
                subjectlist.questionaryId,
                item.questionId
              )
            "
            :key="index"
            :name="item.optionCode"
            >{{ item.optionCode }}.{{ item.optionName }}</van-radio
          >
        </van-radio-group>
        <div class="tiankognti" v-if="subjectlist.type == 0">
          <van-field
            v-model="R_idnex"
            center
            clearable
            label="答案"
            placeholder="请输入答案"
          >
            <template #button>
              <van-button
                size="small"
                type="primary"
                @click="
                  getanswer(
                    subjectlist.id,
                    R_idnex,
                    subjectlist.questionaryId,
                    subjectlist.id
                  )
                "
                >确认</van-button
              >
            </template>
          </van-field>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    radio: {
      type: String,
      default: "",
    },
    SR_idnex: {
      type: Number,
      default: null,
    },
    subjectlist: {
      type: Object,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      R_idnex: null,
    };
  },
  methods: {
    getanswer(id, index, questionaryId, questionId) {
      this.$emit("getanswer", id, index, questionaryId, questionId);
    },
  },
};
</script>

<style lang="scss" scoped>
.wwww {
  width: 100vw;
  max-height: 100vh;
  font-family: "SimSun";
  .subject_name {
    margin-left: 3vw;
    width: 95%;
    font-size: 16px;
    margin-bottom: 2vh;
    margin-top: 2vh;
  }
  .subject_option {
    margin-left: 3vw;
    width: 95%;
    font-size: 16px;
    .subject_radio {
      margin-bottom: 1vh;
      font-size: 16px;
    }
  }
}
</style>